<style lang="scss" scoped>
.btn-back {
  color: $white;
  background-color: $payment-back-btn-color;
  border-color: $payment-back-btn-border;
}

@media (max-width: 700px) {
  .text-xl {
    font-size: 1.4rem;
  }
}
@media (max-width: 490px) {
  .text-xl {
    font-size: 1rem;
  }
}
</style>
<template>
  <div class="p-md-5">
    <div class="pb-2 d-flex flex-wrap justify-content-around">
      <p class="text-center text-xl">
        Wie viele {{ appCurrency }} möchten Sie kaufen?
      </p>
    </div>
    <vue-slider
      id="coins"
      tooltip="false"
      :min="minAmount"
      :max="maxAmount"
      v-model.number="coins"
    />
    <div class="slider-info-text mx-auto p-3 mt-3 text-center border rounded">
      Schiebe einfach nach links oder rechts um {{ appCurrency }} zu wählen und
      wähle dann deine gewünschte Bezahlmethode durch klicken auf ein Logo.
      <strong>Achtung</strong>, hierbei handelt es sich um einen einmaligen
      Kauf, <strong>kein Abonnement</strong>.
    </div>
    <div class="row mt-5">
      <div class="col-md-9 order-md-2 mb-3">
        <button
          class="h-100 w-100 btn btn-success text-xl buy-button"
          @click="buy"
        >
          Jetzt kostenpflichtig {{ coins }} {{ appCurrency }} für
          <i v-if="loadingPrice" class="fas fa-spinner fa-spin"></i>
          <span v-else>{{ priceString }}</span>
          kaufen
          <div v-if="hasBonus" class="font-weight-bold">
            BONUS: <i v-if="loadingPrice" class="fas fa-spinner fa-spin"></i>
            <span v-else>{{ bonus }}</span> {{ appCurrency }} GRATIS dazu!
          </div>
        </button>
      </div>
      <div class="col-md-3 order-md-1 mb-3">
        <button
          @click="back"
          type="button"
          class="h-100 w-100 btn btn-back text-xl"
        >
          Zurück
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from "@/js/currency";
import { debounce } from "lodash";

export default {
  props: {
    service: Object,
    minAmount: Number,
    maxAmount: Number,
    suggestedAmount: Number,
    name: String
  },
  data() {
    return {
      coins: this.checkSuggestedAmount(),
      bonus: null,
      price: null,
      loadingPrice: false,
      setPriceFromCoinsDebounced: function() {}
    };
  },
  computed: {
    priceString() {
      return formatCurrency(this.price);
    },
    appCurrency() {
      return Laravel.lang.currency;
    },
    hasBonus() {
      return this.bonus && this.bonus > 0;
    },
    hasPaymentMethods() {
      return Object.keys(this.service).length > 0;
    }
  },
  methods: {
    back() {
      this.$emit("back");
    },
    buy() {
      this.$emit("buy", {
        method: this.name,
        price: this.price,
        coins: this.coins
      });
    },
    setPriceFromCoins() {
      this.$http
        .get("api/v1/payment/price-from-amount", {
          params: {
            amount: this.coins
          }
        })
        .then(({ data }) => {
          this.price = data.price;
          if (this.service.bonus) {
            this.bonus = data.bonus;
          }
          this.loadingPrice = false;
        });
    },
    checkSuggestedAmount() {
      if (this.suggestedAmount < this.minAmount) {
        return this.minAmount;
      } else if (this.suggestedAmount > this.maxAmount) {
        return this.maxAmount;
      } else {
        return this.suggestedAmount;
      }
    }
  },
  created() {
    this.setPriceFromCoins();
    this.setPriceFromCoinsDebounced = debounce(this.setPriceFromCoins, 100);
  },
  watch: {
    coins() {
      this.loadingPrice = true;
      this.setPriceFromCoinsDebounced();
    }
  }
};
</script>
